import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "448px",
	height: "444px",
	viewBox: "0 0 448 444",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "arrow-right"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			children: /* @__PURE__ */ _jsx("g", {
				id: "arrow-left",
				transform: "translate(224.000000, 222.000000) scale(-1, 1) translate(-224.000000, -222.000000) ",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M229.9,439.899 L249.699,420.1 C254.385,415.414 254.385,407.816 249.699,403.129 L94.569,248 L436,248 C442.627,248 448,242.627 448,236 L448,208 C448,201.373 442.627,196 436,196 L94.569,196 L249.699,40.87 C254.385,36.184 254.385,28.586 249.699,23.899 L229.9,4.101 C225.214,-0.585 217.616,-0.585 212.929,4.101 L3.515,213.515 C-1.171,218.201 -1.171,225.799 3.515,230.486 L212.929,439.9 C217.615,444.586 225.213,444.586 229.9,439.899 Z",
					id: "Path"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
